import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import Auth from "@/pages/Auth";
import Home from "@/pages/Home";
import Workspace from "@/pages/Workspace";
import Timeline from "@/pages/Timeline";
import Admin from "@/pages/Admin";
import Export from "@/pages/Export";
import PublicBrief from "@/pages/PublicBrief";

function Protected({ children }) {
  const { user, loading } = useAuth();
  const loc = useLocation();
  if (loading)
    return (
      <div className="flex min-h-screen items-center justify-center">
        <div className="h-6 w-6 animate-spin rounded-full border-2 border-ikb border-t-transparent" />
      </div>
    );
  if (!user) return <Navigate to="/login" state={{ from: loc }} replace />;
  return children;
}

function PublicOnly({ children }) {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (user) return <Navigate to="/" replace />;
  return children;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<PublicOnly><Auth mode="login" /></PublicOnly>} />
            <Route path="/register" element={<PublicOnly><Auth mode="register" /></PublicOnly>} />
            <Route path="/" element={<Protected><Home /></Protected>} />
            <Route path="/decision/:id" element={<Protected><Workspace /></Protected>} />
            <Route path="/timeline" element={<Protected><Timeline /></Protected>} />
            <Route path="/admin" element={<Protected><Admin /></Protected>} />
            <Route path="/export/:id" element={<Protected><Export /></Protected>} />
            <Route path="/brief/:token" element={<PublicBrief />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
